import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild, Output } from '@angular/core';
import {
  ApplicationRouteURL,
  RoleLevel,
  IAPIResponse,
  PermissionType,
  IKeyValueInterface
} from '../../shared/config';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { TermsConditionPopup } from '../models/terms-condition-popup.service';
import { TermsConditionActivityLog } from '../models/terms-condition.model';
import { EventEmitter } from 'events';
import { TNCAction, TNCAcceptanceMoment } from '../../shared/models/enum-helper';

@Component({
  selector: 'Wego-Popup-TermsAndCondition',
  template: require('../views/terms-condition-popup.component.html'),
  providers: [TermsConditionPopup]
})
export class ViewTermsAndConditionPopupComponent implements OnInit {
  termsAndConditionName: any;
  urlTermsAndConditionPopup: string;
  termsConditionActivityLogModel: TermsConditionActivityLog;
  instanceHashID: string;
  termsAndConditionHashId: string;
  apiErrorMsg: string;
  errorModel: IKeyValueInterface[];
  errorMessage: string;
  bodyHTMLText: string;
  isLoading: boolean = false;
  private curIndex = 0;
  private TotalTNC = 0;
  termsAndCondList: any[];

  constructor(
    public authService: AuthService,
    private locationService: Location,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private termsConditionPopup: TermsConditionPopup
  ) { }

  ngOnInit() {
    this.termsConditionActivityLogModel = new TermsConditionActivityLog();
    this.urlTermsAndConditionPopup = this.authService.GetURL(
      ApplicationRouteURL.URL_TERMS_AND_CONDITION_POPUP
    );
    this.CheckAccountActivationTermsConditionStatus();
  }

  public CheckAccountActivationTermsConditionStatus() {
    this.isLoading = true;
    this.termsConditionPopup.GetTermsConditionForDriver([TNCAcceptanceMoment.ACCOUNT_ACTIVATION, TNCAcceptanceMoment.EVERY_TIME_OPEN_APP, TNCAcceptanceMoment.REPEAT_TIME_OPEN_APP]).subscribe(
      res => {
        if (res.data && res.data.length == 0) {
          const isAccepted: boolean = res.data.accepted;
        } else {
          this.termsAndCondList = res.data;
          this.curIndex = 0;
          this.termsAndConditionName = this.termsAndCondList[0].name;
          this.TotalTNC = this.termsAndCondList.length;
          this.bodyHTMLText = res.data[0].content;
          this.termsAndConditionHashId = res.data[0].termsAndConditionsHashId;
        }

        this.isLoading = false;
      },
      error => {
        this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public NavigateTo() {

    this.router.navigate(['/privacystatement/popup']);
  }

  public OnRejectClick(action: number) {
    this.ActionOnAccountActivationTermsCondition(
      this.termsAndConditionHashId,
      TNCAction.REJECTED
    );
  }

  public Logout() {
    this.authService.Logout();
    this.router.navigate(['/']);
  }

  OnAcceptClick(action: number) {
    this.ActionOnAccountActivationTermsCondition(
      this.termsAndConditionHashId,
      TNCAction.ACCEPTED
    );
  }

  public ActionOnAccountActivationTermsCondition(
    tncHashId: string,
    action: number
  ) {
    this.termsConditionPopup
      .ActionOnAccountActivationTermsCondition(tncHashId, action,'','',[TNCAcceptanceMoment.ACCOUNT_ACTIVATION, TNCAcceptanceMoment.EVERY_TIME_OPEN_APP, TNCAcceptanceMoment.REPEAT_TIME_OPEN_APP])
      .subscribe(
        res => {
          if (action == TNCAction.ACCEPTED) {
            this.curIndex = this.curIndex + 1;
            if (this.curIndex == this.TotalTNC) {
              this.NavigateTo();
            } else {
              this.termsAndConditionName = this.termsAndCondList[this.curIndex].name;
              this.bodyHTMLText = this.termsAndCondList[this.curIndex].content;
              this.termsAndConditionHashId = this.termsAndCondList[this.curIndex].termsAndConditionsHashId;
            }
          } else {
            this.Logout();
          }
          console.log('T&C updated successfully');
        },
        error => { }
      );
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/termsconditionpopup/components/terms-condition-popup.component.ts